import { Theme } from '@mui/material/styles';

export default function Menu(theme: Theme) {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          margin: theme.spacing(0.5),
          borderRadius: '6px',
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          },
          svg: {
            marginRight: 1,
          },
          // Tighten the gap between a MenuItem's leading icon and its label.
          // MUI's default ListItemIcon minWidth is 56 px — clearly aimed at the
          // big navigation lists, but it leaves ~32 px of dead space inside our
          // kebab menus. Pulling it down to the icon's intrinsic size (18 px)
          // plus a single-unit gap unifies every kebab we've added: the
          // Konnektoren / E-Mail row menus, the ConnectorDetail header menu,
          // and the DataGrid GridActionsCellItem menus on the Verbräuche &
          // AllEntries tables — they all bottom out at the same Menu primitive,
          // so this single override aligns them in one place.
          '& .MuiListItemIcon-root': {
            minWidth: 'auto',
            marginRight: theme.spacing(1),
          },
        },
      },
    },
  };
}
